// extracted by mini-css-extract-plugin
export default {"container":"styles_container__xVcn5","label":"styles_label__rBXw-","inputWrapper":"styles_inputWrapper__q0JV6","input":"styles_input__wDJNI"};